const en = {
  "Home.taskName": "Task Name",
  "Home.addNewTask": "Add new Task",
  "Home.noTask": "you have no task yet. Add a new one!",
  "Nav.deleteAllTask": "Delete all task",
};

export default en;
